export const Content={
    ACTION: "Action",
    TOTAL_RESULT: "Total Results",
    INITALPAGENO: 1
}